import { FC, useState } from "react";
import { Box, Typography } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import { useStyles } from "../style";
import { updateDaFeedbackReport } from "actions/daFeedbackActions";
import { useDispatch } from "react-redux";
import { useNav } from "hooks/useNav";
import { ModalWindow } from "components/templateComponents/modalWindow";
import { SubmitDaFeedbackDialog } from "components/modals/modalContent/SubmitDaFeedbackDialog";
import { TIME_ZONE } from "constants/constants";
import moment from "moment";
import { DaFeedbackCurrentReport } from "types/DaFeedback";

interface PropsType {
  currentReport: DaFeedbackCurrentReport | null;
}

export const WeeklyScheduleFeedbackStatus: FC<PropsType> = ({ currentReport }) => {
  const classes = useStyles();

  const expiredCondition =
    TIME_ZONE.isoWeekday() >= 5 || moment().isBefore(moment(currentReport?.created));

  return (
    <>
      {currentReport?.is_submitted && (
        <Alert severity="success" className={classes.alertColor}>
          Dates has been submitted
        </Alert>
      )}
      {!currentReport?.is_submitted && expiredCondition ? (
        <Alert severity="warning" className={classes.warningColor}>
          Expired
        </Alert>
      ) : null}
    </>
  );
};

export const SelectScheduleDates: FC<PropsType> = ({ currentReport }) => {
  const { id } = useNav().pageParams;
  const classes = useStyles();
  const dispatch = useDispatch();
  const [selectedDates, setSelectedDates] = useState<number[]>([]);

  const submitDates = () => {
    dispatch(
      updateDaFeedbackReport({
        id,
        data: selectedDates,
      }),
    );
  };

  const selectDates = (id: number) => {
    !selectedDates.includes(id)
      ? setSelectedDates([...selectedDates, id])
      : setSelectedDates(selectedDates.filter((item) => item !== id));
  };

  const expiredCondition =
    (TIME_ZONE.isoWeekday() >= 5 && TIME_ZONE.hour() > 17) ||
    moment().isBefore(moment(currentReport?.created));

  return (
    <Box>
      <Box className={classes.buttonBox}>
        {currentReport?.schedule_content.map(
          (item: { id: number; is_available: boolean; date: string }) => (
            <Box
              onClick={() => selectDates(item.id)}
              className={`${classes.dateBox} ${selectedDates.includes(item.id) || item.is_available ? classes.activeDateBox : ""} ${currentReport?.is_submitted || expiredCondition ? classes.disabled : ""}`}
              key={item.date}
            >
              <Typography>
                ({moment(item.date, "YYYY-MM-DD HH:mm:ss").format("dddd").substring(0, 3)}){" "}
                {item.date}
              </Typography>
            </Box>
          ),
        )}
      </Box>
      <Box>
        <ModalWindow
          buttonType={"text"}
          modal_name={"submit-availability-dates"}
          modalTitle={"Submit Availability Dates"}
          buttonText={"Submit Dates"}
          modalDescription={"Submit chosen availability dates?"}
          isDisabled={currentReport?.is_submitted || expiredCondition}
        >
          <SubmitDaFeedbackDialog onSubmit={submitDates} />
        </ModalWindow>
      </Box>
    </Box>
  );
};
